import { BASE_URL } from 'src/components/10-atoms/seo/constants';
import getHeirarchyJsonLD from './getHeirarchyJsonLD';
export default function getQuestionPageJsonLd({ questionID, questionString, answerPlainText, hasAnswer, ancestorsDetails, knownNodes, }) {
    const questionUrl = `${BASE_URL}/exam-prep/question/${questionID}`;
    const mainEntity = {
        '@type': 'Question',
        name: questionString,
        text: questionString,
        url: questionUrl,
        answerCount: hasAnswer ? 1 : 0,
        ...(answerPlainText && {
            acceptedAnswer: {
                '@type': 'Answer',
                text: answerPlainText,
            },
        }),
    };
    return {
        '@context': 'https://schema.org',
        '@graph': [
            questionString && {
                '@type': 'QAPage',
                mainEntity,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': questionUrl,
                },
            },
            getHeirarchyJsonLD(ancestorsDetails, knownNodes),
        ].filter(Boolean),
    };
}
